'use client';

import { Box, Typography } from '@mui/material';

import { Logo } from '@/components';
import { useT } from '@/hooks';

export const FooterBrand = () => {
  const { t } = useT();
  return (
    <Box sx={{ mb: { xs: 4, md: 0 } }}>
      <Box sx={{ mb: 3, display: 'flex', alignItems: 'center' }}>
        <Logo iconSize={32} fontSize="2rem" />
      </Box>
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{ maxWidth: 300, lineHeight: 1.7, opacity: 0.8 }}
      >
        {t('footer.brandDesc')}
      </Typography>
    </Box>
  );
};
